module.exports = __webpack_public_path__ + "img/c++.318f32c9.svg";